import semver from 'semver';

/** Versions that were published as an NPM package, and so have the package and SDK docs pages. */
export function hasNpmPackage(version: string | undefined): boolean {
  return Boolean(version && semver.gte(version, '3.0.0'));
}
